module.exports = {"320614102":"海永镇","320614103":"常乐镇","320614104":"悦来镇","320614105":"四甲镇","320614106":"余东镇","320614107":"正余镇","320614400":"南通市海门区经济技术开发区","320614401":"南通市海门区永隆沙农场","320614403":"南通市海门区大东农场","320614404":"南通市海门区畜禽良种场","320614405":"南通市海门区种羊场","320614406":"南通市海门区包场渔场","320614407":"南通市海门区长江芦荡养殖场","320614408":"南通市海门市沿江渔场","320614409":"南通市海门区三厂苗圃","320614410":"南通市海门区农科所","320614412":"南通市海门区财政局芦荡管理所","320614413":"江苏省国营江心沙农场","320614414":"南通市海门区临江新区管理委员会","320614415":"海门港新区","320614416":"三星镇（叠石桥家纺产业园区）","320614418":"三厂工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320614.json
// module id = 977
// module chunks = 0